import { Box, Radio, Tooltip, Typography } from "@mui/material";
import { useState, useRef, useEffect } from "react";
import styles from './VideoSettingIcon.module.css';
import setting from '../../assets/images/setting.svg';
import back from '../../assets/images/back.png';
import { useVideoQualityOptions } from "@vidstack/react";

const VideoSettingIcon = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [rotated, setRotated] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [selectedSpeed, setSelectedSpeed] = useState(1);
  const iconRef = useRef<HTMLDivElement | null>(null);
  const options = [
    { value: "0.5", label: "0.5x" },
    { value: "0.75", label: "0.75x" },
    { value: "1", label: "1x" },
    { value: "1.25", label: "1.25x" },
    { value: "1.5", label: "1.5x" },
    { value: "1.75", label: "1.75x" },
    { value: "2", label: "2x" },
  ];
  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
    setSelectedOption(null);
    setRotated(!rotated);
  };

  const handleOptionSelect = (option:any) => {
    setSelectedOption(option);
  };

  const handleBack = () => {
    setSelectedOption(null);
  };

  const handleClickOutside = (e: MouseEvent) => {
    const target = e.target as Node;
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(target) &&
      iconRef.current &&
      !iconRef.current.contains(target)
    ) {
      setIsDropdownOpen(false);
      setRotated(false); 
    }
  };

  // Close the dropdown when clicking outside of it
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const opts = useVideoQualityOptions({ auto: true, sort: 'descending' });
  
  const curH = opts.selectedQuality?.height;
  const hint =
    opts.selectedValue !== 'auto' && curH
      ? `${curH}p`
      : `Auto${curH ? ` (${curH}p)` : ''}`;

      const handleSelect = (select: () => void) => {
        select();
        setIsDropdownOpen(false);
        setRotated(false);
      };

      const handleSelectChange = (values: any) => {
        const speed = parseFloat(values);
        setSelectedSpeed(speed);
        const videoPlayer = document.querySelector('video');
        if (videoPlayer) {
          videoPlayer.playbackRate = speed;
        }
        setIsDropdownOpen(false);
        setRotated(false);
      };
  return (
    <>
      <Box ref={iconRef} className={styles.settingIconVideoPlayer} onClick={handleDropdownToggle} id="setting_icon">
      <Tooltip
            title="Settings"
            placement="top"
            enterDelay={1500}
            classes={{ tooltip: styles.transparentTooltip }}
            >
            <img
                src={setting}
                alt="setting"
                width={28}
                height={28}
                className={`${styles.settingIcon} ${rotated ? styles.rotated : ''}`}
                style={{cursor:"pointer"}}
            />
            </Tooltip>

      </Box>

      {isDropdownOpen && (
        <Box ref={dropdownRef} className={styles.dropdown}>
          {!selectedOption ? (
            <div className={styles.dropdownContent}>
              <div
                className={styles.dropdownItem}
                onClick={() => handleOptionSelect("playback")}
              >
                Playback speed
              </div>
              <div
                className={styles.dropdownItem}
                onClick={() => handleOptionSelect("quality")}
              >
                Video Quality <span className={styles.hint}>({hint})</span> 
              </div>
            </div>
          ) : (
            <div className={styles.dropdownContent}>
              <div className={styles.dropdownHeader} onClick={handleBack} style={{cursor:"pointer"}}>
                <img src={back} alt="back"  width={12} height={12} />
                <span style={{ paddingLeft: "12px" }}>{selectedOption === "playback" ? "Playback Speed" : "Video Quality"}</span>
              </div>

              {selectedOption === "playback" && (
                <ul style={{cursor:"pointer"}}>
                  {options.map((va)=>{
                    return (<li onClick={()=>handleSelectChange(va.value)} style={selectedSpeed.toString()===va.value && {color:"yellow"}||{color:"white"}}>{va.label}</li>)
                  })}
                </ul>
              )}

              {selectedOption === "quality" && (
                <>
                {opts.map(({ label, value, select }) => {
                  const selected = value === opts.selectedValue;
                  return (
                    <div
                      key={value}
                      onClick={() => handleSelect(select)} className={`d-flex ${styles.videoQualityOption}`} style={{cursor:"pointer"}}
                    >
                      <Radio
                        size="small"
                        checked={selected}
                        sx={{
                          p: 0,
                          color: 'common.white',
                        }}
                      />
                      <Typography
                        variant="body2"
                        sx={{ flexGrow: 1, color: 'common.white', lineHeight: "1" }}
                      >
                        {label}
                      </Typography>
                    </div>
                  );
                })
                }
                </>
                
              )}
            </div>
          )}
        </Box>
      )}
    </>
  );
};

export default VideoSettingIcon;
